// # Reset password utility functions
import { auth } from '../auth/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

/**
 * # Sends a password reset email using Firebase Authentication
 * @param {string} email - The user's email address
 * @returns {Promise<{success: boolean, message: string}>} Result of the operation
 */
export const sendResetPasswordEmail = async (email) => {
  try {
    // # Configure Firebase Auth action code settings
    const actionCodeSettings = {
      // # URL you want to redirect back to after password reset
      url: `${window.location.origin}/signin`,
      // # This must be true for email link sign-in
      handleCodeInApp: true
    };

    // # Send password reset email through Firebase
    await sendPasswordResetEmail(auth, email, actionCodeSettings);

    return {
      success: true,
      message: 'Password reset email sent successfully. Please check your inbox and spam folder.'
    };
  } catch (error) {
    console.error('Firebase reset email error:', error);
    
    // # Handle Firebase-specific error codes
    let errorMessage = '';
    switch (error.code) {
      case 'auth/user-not-found':
        errorMessage = 'No account found with this email address.';
        break;
      case 'auth/invalid-email':
        errorMessage = 'Please enter a valid email address.';
        break;
      case 'auth/too-many-requests':
        errorMessage = 'Too many attempts. Please try again later.';
        break;
      case 'auth/network-request-failed':
        errorMessage = 'Network error. Please check your internet connection.';
        break;
      case 'auth/invalid-continue-uri':
        errorMessage = 'Invalid redirect URL. Please contact support.';
        break;
      case 'auth/unauthorized-continue-uri':
        errorMessage = 'Unauthorized redirect URL. Please contact support.';
        break;
      default:
        errorMessage = 'An error occurred. Please try again or contact support.';
    }

    return {
      success: false,
      message: `${errorMessage} (${error.code})`
    };
  }
};
